export default "__VITE_ASSET__QA3VdGXA__"